// ** React Imports
import { lazy } from 'react';

const ProductRoutes = [
  {
    path: 'catalog/products',
    component: lazy(() => import('views/products')),
  },
  {
    path: 'catalog/products/details/:uuid',
    component: lazy(() => import('views/products/product-details')),
  },
  {
    path: 'product/add',
    component: lazy(() => import('views/products/products-add')),
  },
  {
    path: 'product/:uuid',
    component: lazy(() => import('views/products/product-edit')),
  },
  {
    path: 'product-clone/:uuid',
    component: lazy(() => import('views/products/product-clone')),
  },
  {
    path: 'catalog/product/import',
    component: lazy(() => import('views/products/product-import')),
  },
  {
    path: 'catalog/product/variant-import',
    component: lazy(() => import('views/products/product-variant-import')),
  },
  {
    path: 'product-request/:id',
    component: lazy(() => import('views/products/product-request-edit')),
  },
  {
    path: 'product-request-details/:id',
    component: lazy(() => import('views/products/product-request-detail')),
  },
];

export default ProductRoutes;
